/** Canonical origin: cuidei.com.br and www.cuidei.com.br both answer, engines are pointed at the apex. */
export const CUIDEI_ORIGIN = 'https://cuidei.com.br'

/** Same scope as the `.*cuidei.*` host rewrites in next.config.js. No imports: the middleware loads it. */
export const isCuideiHost = (host: string | string[] | null | undefined): boolean => {
  const value = Array.isArray(host) ? host[0] : host
  return (value ?? '').toLowerCase().includes('cuidei')
}

/**
 * The internal Cuidei routes (/patologia/<slug>, its /preview and /consulta, and /cuidei-hub behind
 * cuidei.com.br/) only exist on Cuidei hosts. The published landing is static (ISR) and cannot check the host itself, so the middleware does.
 */
export const isForeignPathologyRequest = (host: string | null | undefined, path: string): boolean =>
  (path === '/patologia' || path.startsWith('/patologia/') || path === '/cuidei-hub') && !isCuideiHost(host)

/**
 * www.cuidei.com.br/llms.txt → https://cuidei.com.br/llms.txt (301). Only the llms.txt file (PRD of
 * 04/11/2026): the pages keep answering on both hosts with a canonical tag, as before.
 */
export const cuideiCanonicalRedirect = (host: string | null | undefined, path: string): string | undefined => {
  const hostname = (host ?? '').split(':', 1)[0].trim().toLowerCase()
  return hostname === 'www.cuidei.com.br' && path === '/llms.txt' ? `${CUIDEI_ORIGIN}${path}` : undefined
}
